/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { ticketColors } from '../theme/public-api';
import { modalExperience } from './modalExperience.styles';

type Props = {
  label: string;
  value: string;
  onPress: () => void;
  active?: boolean;
  disabled?: boolean;
  accessibilityLabel?: string;
};

export function ModalFilterSelectTrigger({
  label,
  value,
  onPress,
  active = false,
  disabled = false,
  accessibilityLabel,
}: Props) {
  return (
    <>
      <Text style={modalExperience.filterFieldLabel}>{label}</Text>
      <TouchableOpacity
        style={[
          modalExperience.filterSelectTrigger,
          active && modalExperience.filterSelectTriggerActive,
          disabled && { opacity: 0.5 },
        ]}
        onPress={onPress}
        disabled={disabled}
        accessibilityRole="button"
        accessibilityLabel={accessibilityLabel ?? label}
        accessibilityState={{ disabled }}
      >
        <View style={modalExperience.filterSelectMain}>
          <Text style={modalExperience.filterSelectValue} numberOfLines={1}>
            {value}
          </Text>
        </View>
        <Ionicons name="chevron-down" size={18} color={ticketColors.ink2} />
      </TouchableOpacity>
    </>
  );
}
